<app-breadcrumbs [title]="'MENU.SETTINGS.DEFAULT_EMAIL_TEMPLATES'" [first]="'MENU.SETTINGS.DEFAULT_EMAIL_TEMPLATES'"></app-breadcrumbs>

<div class="row">
    <div class="col-12">
        <app-email-templates #emailTemplatesComponent [default]="true" [emailTemplates]="emailTemplates" [canUpdate]="canUpdate"
            (saveSingleEvent)="saveTemplate($event)" (deleteSingleEvent)="deleteTemplate($event)"></app-email-templates>
    </div>
</div>
